// src/pages/WFHHistory.js
import React, { useEffect, useState } from "react";
import "./WFHHistory.css";
import apiClient from "../utils/apiClient"; // centralized API client
import SessionHandler from "../components/SessionHandler"; // global session expiry modal

const WFHHistory = () => {
  const [requests, setRequests] = useState([]);
  const [statusFilter, setStatusFilter] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchWFHHistory = async () => {
      setLoading(true);
      setError("");
      try {
        const data = await apiClient("/wfh/self/");
        if (data) {
          setRequests(Array.isArray(data.results) ? data.results : []);
        }
      } catch (err) {
        console.error("Error fetching WFH history:", err);
        setError("Failed to fetch WFH history.");
        setRequests([]);
      } finally {
        setLoading(false);
      }
    };

    fetchWFHHistory();
  }, []);

  const filteredRequests = requests.filter(
    (req) =>
      statusFilter === "" ||
      req.status.toLowerCase() === statusFilter.toLowerCase()
  );

  const calculateDays = (start, end) => {
  if (!start || !end) return 0;

  const [sy, sm, sd] = start.split("-").map(Number);
  const [ey, em, ed] = end.split("-").map(Number);

  const startDate = new Date(sy, sm - 1, sd);
  const endDate = new Date(ey, em - 1, ed);

  const diff =
    Math.round((endDate - startDate) / (1000 * 60 * 60 * 24)) + 1;

  return diff > 0 ? diff : 1;
};


  return (
    <div className="leave-history-container">
      <h2>Work From Home History</h2>

      <div className="filter-controls">
        <select
          value={statusFilter}
          onChange={(e) => setStatusFilter(e.target.value)}
        >
          <option value="">All Status</option>
          <option value="PENDING">Pending</option>
          <option value="APPROVED">Approved</option>
          <option value="REJECTED">Rejected</option>
        </select>
      </div>

      {loading ? (
        <p>Loading...</p>
      ) : error ? (
        <p className="error">{error}</p>
      ) : filteredRequests.length === 0 ? (
        <p className="no-records">No WFH records found.</p>
      ) : (
        <table className="leave-table1">
          <thead>
            <tr>
              <th>Reason</th>
              <th>Start Date</th>
              <th>End Date</th>
              <th>Days</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {filteredRequests.map((req, index) => (
              <tr key={index}>
                <td>{req.reason || "—"}</td>
                <td>{req.start_date}</td>
                <td>{req.end_date}</td>
                <td>{calculateDays(req.start_date, req.end_date)}</td>
                <td className={`status ${req.status.toLowerCase()}`}>
                  {req.status}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {/* Global session expiry modal */}
      <SessionHandler />
    </div>
  );
};

export default WFHHistory;
